//in this file we write the encryption algorithms and usages
const CryptoJS = require("crypto-js");
import { encryptionKey } from "config";

export const AESEncrypt = plainText => {
  return CryptoJS.AES.encrypt(plainText, encryptionKey).toString();
};

export const AESDecrypt = encryptedText => {
  return CryptoJS.AES.decrypt(encryptedText, encryptionKey).toString(
    CryptoJS.enc.Utf8
  );
};

export const sha256 = plainText => {
  return CryptoJS.SHA256(plainText).toString(CryptoJS.enc.Base64);
};
